import is, { isNot } from 'typescript-styled-is'
import styled, { ITheme } from '../../../theme'
import { Input as BaseInput } from '../elements'
import { IInputProps } from '../elements/Input'

const Input = styled(BaseInput)<IInputProps & { alignCurrency?: boolean; little?:boolean }>`
  min-width: 30px;
  text-align: left;
  text-align: start;
  background: none;
    ${({ little }) => little ? 'height: 24px !important' : ''};

  color: ${(props: ITheme) => props.theme.colors.palette.darkGreyTwo};

  padding: 0
    ${({ size, alignCurrency }) =>
      alignCurrency ? (size ? 88 * size : 88) : size ? 64 * size : 64}px
    0 ${({ size }) => (size ? 20 * size : 20)}px;

    ${is('little')`
        padding: 0 42px 0 0px;
        `};
    
  ${is('withAfterIcon')`
  padding-right: ${({ size, alignCurrency }) =>
    alignCurrency ? (size ? 88 * size : 88) : size ? 75 * size : 75}px;
`}
  
  ${isNot('currency')`
    padding: 0 5px;
  `}
  
  ${is('disabled')`
    background-color: #F5F5F5;
    color: #858585;
  `}

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;
    
  ${is('little')`
    color: #A1A1A1;

text-align: right;
font-family: Montserrat;
font-size: 10px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: 0.02px;
  `};
`

export default Input
